<template>
  <SentimentGauge
    :title="title"
    :item-id="itemId"
    :owner-posts="true"
    v-bind="$attrs"
  />
</template>

<script>
import SentimentGauge from '@/components/cards/SentimentGauge';
import proprietaryModel from '@/mixins/proprietary-model';

export default {
  name: 'PropSentimentGauge',
  components: {
    SentimentGauge,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

